import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';
import styled from "styled-components";
import { useDispatch, useSelector } from 'react-redux';
import * as moment from 'moment';
import RightArrowLight from "web/assets/images/right-arrow-sell.png";
import Button from 'web/components/Button';
import AlertModal from 'web/components/AlertModal';
import { stateConvert } from 'web/components/utils/stateAbbreviation';
import { sellerInvCheckoutRejectApi, sellerInvCheckoutAcceptApi } from 'redux/actions/checkout';
import DummyPallets from 'web/assets/images/pallet-home-image.jpg';
import {
    DateTimeWrapper1,
    InputWrapper,
    OrderDetail,
    PayWith,
    Address,
    ReviewOrder,
    Heading,
    Location,
    To,
    ReviewFooter,
    Des,
    CommentSection,
} from '../checkOutStyle';
import { fetchLanguageContentNew } from 'redux/actions/language';

const SellerInventory = ({ checkoutPageData, props, searchParamCheckoutOfferId }) => {
  const dispatch = useDispatch();
  let history = useHistory();
  const urlObject = useSelector((state) => state.urlParameters.checkout);
  const fileUrl = process.env.REACT_APP_API_URL + '/user/image/';
  const token = localStorage.getItem('token');

  const currentLanguage = useSelector(state => state.language.currentLanguage)
  const languageContentNew = useSelector(state => state.language.languageContentNew)
  const [pageLanguageContents, setPageLanguageContents] = useState()

  const [alertType, setAlertType] = useState('')
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);

  useEffect(() => {
    if (languageContentNew?.Pallets_Listing_Pages) setPageLanguageContents(languageContentNew.Pallets_Listing_Pages)
    else dispatch(fetchLanguageContentNew(currentLanguage))
  }, [languageContentNew])

  const btnsAttach = () => {
    return (
      <>
        <>
          <div className="checkout-note">
            <Heading>Note to Buyer</Heading>
            <div className="app-input-text">
              <textarea
                name="note"
                maxLength="500"
                onChange={(event) => {
                  const { setFieldValue } = props
                  setFieldValue('note', event.target.value)
                }}
              />
            </div>
          </div>
        </>
        <small class="" style={{ "font-size": "11px" }}><em>By accepting this offer, you agree to satisfy the pickup or delivery requirements set forth in the details of the order.</em></small>
        <ReviewFooter>
          <Button
            type=''
            handleClick={() => declineFunction()}>
            {pageLanguageContents?.BuyModal[40]?.Reject}
          </Button>
          <Button
            type=''
            handleClick={() => acceptFunction()}
          >
            {pageLanguageContents?.BuyModal[41]?.Accept}
          </Button>
        </ReviewFooter>
      </>
    );
  };

  const declineFunction = async () => {
    let response;
    let data = {
      authId: localStorage.getItem('authId'),
      offerId: urlObject?.id || searchParamCheckoutOfferId,
      comment: props.values?.note ?? null
    }
    response = await dispatch(sellerInvCheckoutRejectApi(data, token));
    if (response?.success) {
      setAlertType('sellerInvCheckoutReject')
      setModalContent(response?.data?.msg);
      setModalLink();
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  const acceptFunction = async () => {
    let pageValues = props.values
    let response;
    let data = {
      authId: localStorage.getItem('authId'),
      locationId: localStorage.getItem('locationID'),
      offerId: urlObject?.id || searchParamCheckoutOfferId,
      comments: pageValues?.note,
    }
    response = await dispatch(sellerInvCheckoutAcceptApi(data, token));
    if (response?.success) {
      setAlertType('sellerInvCheckoutAccept')
      setModalContent(response?.data?.msg);
      setModalLink();
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('./sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response?.data?.error?.message || response?.message || 'Something went wrong, please try again in some time.');
        setModalLink("");
        toggleModal();
      }
    }
  }

  return (
    <>
      <div></div>
      <div className="checkout-cont">
        <Description>
          <div className="product-header-sec">
            {/* <img
              src={RightArrow}
              alt="RightArrow"
              className="right-arrow"
            /> */}
            <img
              src={RightArrowLight}
              alt="RightArrow"
              className="right-arrow"
            />

            <div class="community-name">
              {checkoutPageData?.offerStatus === 'PENDING' ? <h4>{pageLanguageContents?.BuyModal[2]?.Checkout}</h4> : <p style={{ fontSize: '22px', fontWeight: 'bold' }}>Accepted</p>}
            </div>
          </div>
          {checkoutPageData?.offerStatus === 'PENDING' && <p>Please review the requirements and accept. Upon acceptance, an order will be created.</p>}
        </Description>
        <PayWith>
          <Location>
            {checkoutPageData?.shippingMode === 'PICKUP' ?
              <Heading>{pageLanguageContents?.BuyModal[7]?.PickupLocation}</Heading>
              :
              <Heading>{pageLanguageContents?.BuyModal[6]?.DeliveryAddress}</Heading>
            }
            {props?.values?.city && props?.values?.city !== '' &&
              <>
                {checkoutPageData?.shippingMode === 'PICKUP' ?
                  <Address>
                    <h2>{props?.values?.name}</h2>
                    <p>{props?.values?.line1}</p>
                    {props?.values?.line2 &&
                      <p>{props?.values?.line2}</p>}
                    <p>{props?.values?.city},&nbsp;{stateConvert(props?.values?.state)}&nbsp;{props?.values?.zip}</p>
                  </Address>
                  :
                  <Address>
                    <p>{props?.values?.city},&nbsp;{stateConvert(props?.values?.state)}&nbsp;{props?.values?.zip}</p>
                    <p className='discalimerStyle'>Full address details will be displayed once the order is authenticated.</p>
                  </Address>}
              </>
            }

            <DateTimeWrapper1>
              {/* bidPostLoad */}
              <DeliveryWindowSection>
                <div>
                  {checkoutPageData?.shippingMode === 'PICKUP' ?
                    <Heading>{pageLanguageContents?.BuyModal[8]?.PickupDate}</Heading>
                    :
                    <Heading>{pageLanguageContents?.BuyModal[11]?.DeliveryDate}</Heading>
                  }
                  <InputWrapper>{moment(checkoutPageData?.requestedDate).format('MM/DD/YYYY')}</InputWrapper>
                </div>
                <div>
                  {checkoutPageData?.shippingMode === 'PICKUP' ?
                    <Heading>{pageLanguageContents?.BuyModal[9]?.PickupTime}</Heading>
                    :
                    <Heading>{pageLanguageContents?.BuyModal[12]?.DeliveryTime}</Heading>
                  }
                  <div className="d-flex align-items-center">
                    <InputWrapper>
                      {checkoutPageData?.appointmentStartTime}
                    </InputWrapper>
                    <To>
                      {pageLanguageContents?.BuyModal[10]?.To}
                    </To>
                    <InputWrapper>
                      {checkoutPageData?.appointmentEndTime}
                    </InputWrapper>
                  </div>
                </div>
                <div>
                  <Heading>PO Number</Heading>
                  <InputWrapper>
                    {checkoutPageData?.poNumber}
                  </InputWrapper>
                </div>
              </DeliveryWindowSection>
            </DateTimeWrapper1>

            {checkoutPageData?.buyername && (
              <CommentSection>
                <>
                  <div>
                    <h3>{checkoutPageData?.buyername}<span>:</span></h3>
                    <p>{checkoutPageData?.comments ? checkoutPageData?.comments : ""}</p>
                  </div>
                </>
              </CommentSection>
            )}
          </Location>
        </PayWith>

        <ReviewOrder>
          <Heading>
            {pageLanguageContents?.BuyModal[29]?.ReviewOrder}
          </Heading>
          <OrderDetail>
            <div className="checkout-total">
              <div className="checkout-product-detail">
                <div className="checkout-product-img">
                  <div className="checkout-img p-2 text-center">
                    <img src={checkoutPageData?.postImageFiles ? `${fileUrl}${checkoutPageData?.postImageFiles[0].fileName}` : DummyPallets} />
                  </div>
                </div>
                <div className="checkout-product-desc">
                  <h2>{checkoutPageData?.postName}</h2>
                  <Des>{checkoutPageData?.postComment}</Des>
                </div>
              </div>
              <div className="checkout-count-table">
                <p>
                  <b>{pageLanguageContents?.BuyModal[30]?.Quantity}<span>:</span></b>
                  <span>{checkoutPageData?.qty}&nbsp;</span>
                </p>
                <p>
                  <b>{pageLanguageContents?.BuyModal[33]?.Price_Pallet}<span>:</span></b>
                  <span>
                    <CurrencyFormat
                      prefix={"$"}
                      value={checkoutPageData?.offerPrice?.toFixed(2)}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </span>
                </p>
                <p>
                  <b>{pageLanguageContents?.BuyModal[34]?.Subtotal}<span>:</span></b>
                  <span>
                    <CurrencyFormat
                      prefix={"$"}
                      value={(checkoutPageData?.qty * checkoutPageData?.offerPrice)?.toFixed(2)}
                      displayType={"text"}
                      thousandSeparator={true}
                    />
                  </span>
                </p>

                {checkoutPageData?.offerStatus === 'PENDING' && btnsAttach()}

                {checkoutPageData?.offerStatus !== 'PENDING' &&
                  <p>
                    <b>{pageLanguageContents?.BuyModal[39]?.Status}<span>:</span></b>
                    <span><span className="greenStatus">{checkoutPageData?.offerStatus}</span></span>
                  </p>
                }
              </div>
            </div>
          </OrderDetail>
        </ReviewOrder>
      </div>
      <AlertModal
        isOpen={modal}
        toggle={toggleModal}
        title=''
        content={modalContent}
        link={modalLink}
        alertType={alertType}
        callBackAlert={() => {
          if (alertType === 'sellerInvCheckoutReject') {
            let obj = {
              postType: "PostInventory",
              type: "palletOffers",
              activePage: 'PostInventory',
              expanded: 'panel2'
            }
            dispatch({ type: 'CREATED_INVENTORY', payload: obj })
            history.push({ pathname: "/my-posted-pallet-inventory", });
          } else if (alertType === 'sellerInvCheckoutAccept') {
            let obj = { selectedTab: "PENDING", expanded: "sideBar" }
            dispatch({ type: 'ORDERS', payload: obj })
            history.push('/my-orders')
          }
        }}
      />
    </>
  );
};

export default SellerInventory;

const DeliveryWindowSection = styled.div`
      display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 0 30px;
    @media (max-width:500px) {
      grid-template-columns: 1fr;
    }
`;
const Description = styled.div`
  position: relative;
  padding-left: 62px;

  img.right-arrow {
    position: absolute;
    left: -36px;
  }
  .product-header-sec{
    margin-top: 10px;
    margin-bottom: 10px;
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    @media (max-width: 767px) {
      grid-template-columns: 80% 1fr;
    }
  }
`;
